<div class="dialog-header">
  <div class="flex gap-6">
    <!-- TITLE -->
    <h2 class="flex-grow flex-shrink basis-auto dialog-header__title">
      {{ title() }}
    </h2>
    <!-- /dialog-header__title -->

    <!-- OPTIONAL ACTION BUTTONS -->
    @if (items().length > 0) {
      <div class="flex-grow-0 flex-shrink-0 basis-auto dialog-header__actions">
        <hypecast-master-admin-generic-actions [items]="items()"></hypecast-master-admin-generic-actions>
      </div>
    }
    <!-- /dialog-header__actions -->
    @if (items().length === 0) {
      <div class="flex-grow-0 flex-shrink-0 basis-auto dialog-header__actions">
        <ng-content></ng-content>
      </div>
    }
    <!-- /dialog-header__actions -->

    <!-- CLOSE ICON BUTTON -->
    <div class="flex-none flex-shrink-0 justify-end dialog-header__close-icon-button">
      <button mat-icon-button [matTooltip]="closeTooltipText()" (click)="emitCloseClick.emit(true)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <!-- /dialog-header__close-icon-button -->
  </div>

  <!-- DIVIDER -->
  @if (dividerIsVisible()) {
    <mat-divider class="dialog-header__divider dialog-header__divider--stretched"></mat-divider>
  }
</div>
